import React, { useEffect, useState } from "react";
import { Breadcrumb, Container, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function FaqPage() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.FAQLIST,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status) {
          setFaqs(res.data.data);
        }
      } catch (err) {
        console.error("FAQ API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  // ✅ SEO Setup
  useSEO({
    title: "Frequently Asked Questions | Taxi Service Varanasi",
    description:
      "Find answers to common questions about taxi booking, fares, airport pickup, outstation trips, and services in Varanasi.",
    keywords:
      "FAQ taxi Varanasi, cab booking questions, airport taxi FAQ, outstation taxi help, taxi service support",
    canonical: window.location.href,
    ogImage: "", // optional (add banner if you have)
  });

  return (
    <div>
      <div className="BreadcrumbStyle">
        <Container>
          <h1>Frequently Asked Questions</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              Frequently Asked Questions
            </Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      <Container className="py-5">
        <div className="mt-5">
          <h3 className="mb-4">Frequently Asked Questions</h3>

          {/* Loading */}
          {loading && <p>Loading FAQs...</p>}

          {/* No Data */}
          {!loading && faqs.length === 0 && (
            <p>No FAQs available.</p>
          )}

          {/* Accordion */}
          {!loading && faqs.length > 0 && (
            <Accordion defaultActiveKey="0">
              {faqs.map((item, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                >
                  <Accordion.Header>
                    {item.questions}
                  </Accordion.Header>
                  <Accordion.Body> 
                     <div dangerouslySetInnerHTML={{ __html: item.answers }} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </div>
      </Container>
    </div>
  );
}